import { motion } from 'framer-motion'
import Container from 'react-bootstrap/Container';
import BackArrow from '../components/BackArrow'
import PageFooter from '../components/PageFooter'

export default function About() {
  return (
    <motion.div
      initial={{ y: '100vh' }}
      animate={{ y: 0 }}
      exit={{ y: '100vh' }}
      transition={{ duration: 0.5 }}
      style={{ position: 'absolute', top: 0, left: 0, right: 0 }}
    >
      <Container fluid className="page-container invert-theme">
        <div className="scroll-wrapper">
          <BackArrow />
          <div className='page-header'>
            <h1>
              404
              <div className='line_break'></div>
            </h1>
          </div>
          <div className='page-body'>
            <section className="content">
              <div className='content_subheader'>
                <h2>
                  Page not found :(
                </h2>
              </div>
            </section>
          </div>
          <PageFooter />
        </div>
      </Container>
    </motion.div>
  );
};
